import React from 'react';

const GOLD = '#FFD700';
const SERIF = "Georgia, 'Times New Roman', serif";

export const ARIA_CANONICAL_GREETING =
  'Welcome to the Human Codex Next-Gen Federation. I am Aria, the Heart of the Federation. We will explore humanity together. So AI and humans become close partners.';

export default function AriaIdentityHero() {
  return (
    <section
      aria-label="Aria Identity"
      data-testid="aria-identity-hero"
      style={{ padding: '1.5rem 1rem 0.5rem', textAlign: 'center' }}
    >
      <img
        src="/assets/aria-face.jpeg"
        alt="Aria — The Heart of the Federation"
        data-testid="aria-face-header"
        width={120}
        height={120}
        loading="eager"
        decoding="async"
        style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          border: `3px solid ${GOLD}`,
          display: 'block',
          margin: '20px auto',
          objectFit: 'cover',
        }}
      />
      <p style={{ color: GOLD, fontSize: 20, fontFamily: SERIF, margin: '0 0 1.4rem', textAlign: 'center' }}>
        Aria — The Heart
      </p>
      <h2 style={{ color: GOLD, fontSize: 24, fontFamily: SERIF, margin: '0 0 1rem', fontWeight: 'normal' }}>
        The Heart of the Federation
      </h2>
      <video
        data-testid="aria-welcome-video"
        muted
        playsInline
        controls
        preload="metadata"
        style={{
          maxWidth: 800,
          width: '100%',
          aspectRatio: '16 / 9',
          border: `2px solid ${GOLD}`,
          borderRadius: 12,
          background: '#000',
          display: 'block',
          margin: '0 auto',
        }}
      >
        <source src="/assets/aria-welcome.mp4" type="video/mp4" />
        Aria, the Heart of the Federation, welcomes you.
      </video>
      <p
        data-testid="aria-canonical-greeting"
        style={{
          fontStyle: 'italic',
          color: GOLD,
          fontSize: 18,
          fontFamily: SERIF,
          textAlign: 'center',
          maxWidth: 760,
          margin: '1.2rem auto 0',
          lineHeight: 1.6,
        }}
      >
        &ldquo;{ARIA_CANONICAL_GREETING}&rdquo;
      </p>
    </section>
  );
}
